import axios from 'axios'
import router from '../../router'
import { TokenService } from '../account/storage.service'

axios.interceptors.response.use(
  response => response,
  error => {
    // Error
    console.log("tokenResponse1", error)

    if(error && error.response && error.response.status) {
      console.log("tokenResponse11", error.response)

      const { response: { status } } = error;

      if (status === 401) {
        // Unauthorized request: maybe access token has expired!
        //return refreshAccessToken(config);

        console.log('Warning: Expired Token!')
        TokenService.removeToken();

        console.log('----')
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath },
        }).then(() => {
          console.log('++++')
        }).catch(exc => {
          console.log('====')
          console.log(exc)
        })
        console.log('----')
        
        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    }
  }
);

const ApiService = {

  init(baseURL) {    
    axios.defaults.baseURL = baseURL;
  },

  getBaseUrl() {
    return axios.defaults.baseURL
  },

  initAsync(baseURL) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = baseURL;
      resolve()
    })        
  },

  setHeader() {
      axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
  },

  removeHeader() {
      axios.defaults.headers.common = {}
  },

  get(resource, params) {
      return axios.get(resource, params)
  },

  post(resource, data) {
      return axios.post(resource, data)
  },

  put(resource, data) {
      return axios.put(resource, data)
  },

  delete(resource) {
      return axios.delete(resource)
  },

  deleteFile(resource, payload) {
    return axios.delete(resource, { data: payload })
},

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
  **/
  customRequest(data) {
      return axios(data)
  }
}

export default ApiService
